import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';
import StyledDealflowEntitiesViewsWrapper
  from 'components/templates/Wrappers/Dealflow/DealflowEntitiesViewsWrapper/DealflowEntitiesViewsWrapper.styles';
import DealflowEntitiesTableViews
  from 'components/organisms/TableViews/DealflowEntitiesTableViews/DealflowEntitiesTableViews';

const DealflowEntitiesViewsWrapper = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DealflowEntitiesViewsWrapper');

  const tableProvider = useTable();

  return <StyledDealflowEntitiesViewsWrapper ref={ref} {...innerProps}
                                             variant="foldout"
                                             context={<DealflowEntitiesTableViews />}
                                             open={Boolean(tableProvider.state?.showViews)}
                                             size="oversize"
                                             ContextDrawerProps={{
                                               onToggle: (e, open) => {
                                                 if (open) {
                                                   tableProvider.openViews();
                                                 } else {
                                                   tableProvider.closeViews();
                                                 }
                                               }
                                             }}>
    {innerProps.children}
  </StyledDealflowEntitiesViewsWrapper>
});

DealflowEntitiesViewsWrapper.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DealflowEntitiesViewsWrapper;
